import { InputErrorTemplate } from '@core/errors/error-template';
import { EmailValidator } from '@core/errors/generic-errors';
import { NewsLetterService } from '@core/services/newsletter/newsletter.service';
import { Inject } from '@rxdi/core';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { InputStyle } from '@rxdi/ui-kit/styles/form/input';

/**
 * @customElement subscribe-updates
 */
@Component({
  selector: 'subscribe-updates',
  style: css`
    ${InputStyle}
    .container {
      width: 400px;
      margin: 0 auto;
    }
    h2,
    h1 {
      text-align: center;
    }
  `,
  template(this: SubscribeUpdatesComponent) {
    return html`<div class="container">
      <h2>Stay up to date with</h2>
      <h1>Graphql Cloud updates</h1>
      <form
        name="form"
        novalidate
        @submit=${async () => (await this.form.updateValueAndValidity()) && this.form.valid && this.submit()}
      >
        <input placeholder="Email" required name="email" type="email" class="rx-input" />
        <div style="height: 30px;">${InputErrorTemplate(this.form.get('email'))}</div>
        <rx-button style="width: 100%" palette="warning" type="submit">Subscribe to Updates</rx-button>
      </form>
    </div>`;
  },
})
export class SubscribeUpdatesComponent extends LitElement {
  @Form({ name: 'form', strategy: 'input' })
  private form = new FormGroup({
    email: ['', [EmailValidator]],
  });

  @Inject(NewsLetterService)
  private newsLetterService: NewsLetterService;

  private submit() {
    this.newsLetterService.newsLetterSubscription(this.form.value.email).subscribe((stream) => {
      console.log(stream);
    });
    console.log(this.form.value.email);
  }
}
